import "./HomeTax.css";
import HeaderProtected from "../../componentes/headerProtected/header";
import Sidebar from "../../componentes/sideBar/SideBar";
import RequestsTax from "../../componentes/fluxo-tax/Request-tax/RequestTax";
import { SupportFooter } from "../../componentes/supportFooter/supportFooter";

const HomeTax = () => {
  return (
    <>
      <Sidebar />
      <HeaderProtected />
      <div className="homeMain">
        <RequestsTax />
      </div>
      <SupportFooter />
    </>
  );
};

export default HomeTax;
